module.exports = __webpack_public_path__ + "static/media/fighter-icon.6fcb4998.png";